export const ID = 'id';
export const NAME = 'name';
export const APPLICATIONS = 'applicationIds';
export const TAGS = 'tagIds';
export const REQUESTED_BY = 'requestedById';
export const JIRA_TASK = 'jiraTask';
export const DESCRIPTION = 'description';
export const STATUS_ID = 'statusId';
export const STATE_SCHEDULES = 'stateSchedules';
export const EXPIRATION_DATE = 'expirationDate';
export const UNARCHIVE_DATE = 'unarchiveDate';
export const ORIGINAL = 'original';
export const CONCEPT_FAMILIES = 'conceptFamilyIds';
export const BUSINESS_PARTNERS = 'businessPartnerIds';
export const PROMO_CODE = 'promoCodeId';
export const HAS_STATS = 'hasStats';
export const SIZE = 'size';
export const ATTACHMENTS = 'attachments';
export const AI_GENERATED = 'isAICreated';
